import Chart from "chart.js";



// function updateConfigByMutating(chart) {
//   myPieChart.options.title.text = 'new title';
//   myPieChart.update();
// }




// updateConfigAsNewObject();




// var graph01 = document.getElementById("js-graph-01");
// var graph01Chart = new Chart(graph01, {
//   type: 'doughnut',
//   data: {
//     labels: ["期待している", "あまり期待していない", "内容を知らない"],
//     datasets: [{
//         backgroundColor: [
//             "#105DE1",
//             "#0E4598",
//             "#012262"
//         ],
//         data: [50, 30, 20]
//     }]
//   },
//   options: {
//     title: {
//       display: false,
//       text: '天神ビッグバンについて'
//     },
//     legend: {
//       display: false

//     },
//     tooltips: {
//       enabled: false

//     },
//     cutoutPercentage: 74
//   }
// });